export const oauthKeys = {
    integrations: () => ['integrations'],
    start: (oauthType) => [...oauthKeys.integrations(), 'start', oauthType]
};
//# sourceMappingURL=oauth.keys.js.map